export default __webpack_public_path__ + "static/media/4.b4f0e35b.jpg";